/**
 * The words on Put Yourself In It (screens/PutMeIn.tsx; owner, 2026-10-30,
 * mocks on artifact BiYqKFwuiLEzycxDATLUR6). Held by data/put-me-in-copy.test.ts
 * to the first-screen rules: no banned words, no "AI", no exclamation marks.
 * The photo is "drawn" by "the crew", as everywhere else.
 */
export const PUT = {
  tag: 'You, in it',
  /** 1 · the ask, over their own picture with the plain stand-in in it */
  title: 'Now put yourself in it.',
  body: 'That blank figure is keeping your place. Show the crew your face, and they redraw the picture with you in it.',
  photo: 'Take a selfie',
  privacy: 'Only the crew see your photo. It is never posted.',
  later: 'Not now, it waits on your road',
  /** 2 · a photo is in */
  chosenTitle: 'That’s who goes in.',
  chosenBody: 'The crew keep your face, your hair, your glasses, and draw you in their style.',
  draw: 'Draw me in',
  /** 3 · the tray: they may stay or go, the picture waits on the road */
  drawing: 'Drawing you in',
  drawingTitle: 'The crew are drawing you in.',
  drawingBody: 'It takes about a minute. When it’s dry it goes on your road, so you don’t have to wait here.',
  back: 'Back to my road',
  /** 4 · the reveal, the plain one tucked behind */
  revealTitle: 'There you are.',
  keep: 'Keep this one',
  again: 'Try another photo',
  /** a try that did not come out, back at the ask */
  failed: 'That one didn’t come out. Try another photo.',
  /** no photos left for this picture */
  noMore: 'That’s every photo this picture gets. Keep the one you like.',
  /** the crew are off, so nothing is drawn from a photo */
  crewOff: 'Your crew are off, so they can’t draw you in.',
  /** F · the picker opened and nothing came back (Facebook's browser on Android, 2026-10-30) */
  helpTitle: 'Photo not coming through?',
  helpBody: (app: string, browser: string) => `${app}’s browser sometimes won’t hand photos over. Open your road in ${browser} and it will. Your picture comes with you.`,
  helpClose: 'Try again here',
} as const;
